import PRESET_EVENTS from './util/event';
import { v4 as uuid } from 'uuid';
const isTopFrame = () => window === window.parent;
const ID = '__asphodel_id';
class Client {
    constructor(iframeId) {
        const isRoot = isTopFrame();
        this.parentId = '';
        this.parent = null;
        this.inited = true;
        this.frameMap = {};
        // 关注dom变化，在iframe销毁时取消注册iframe
        this.observer = new MutationObserver(this._observerCallback.bind(this));
        if (!isRoot) {
            this.parentId = this._registerParent();
            this.parent = window.parent;
            this.inited = false;
        }
        this.iframeId = iframeId || '';
        this.context = {};
        this.listener = [];
        this._bindListener();
    }
    _registerParent() {
        const id = `parent-${uuid()}`;
        this.frameMap[id] = this._createFrameTemplate(id, window.parent, true);
        return id;
    }
    _observerCallback(mutationList) {
        mutationList.forEach((mutation) => {
            const { removedNodes } = mutation;
            removedNodes.forEach((node) => {
                const id = node.getAttribute && node.getAttribute(ID);
                if (!id)
                    return;
                Object.keys(this.frameMap).forEach((k) => {
                    if (k === id) {
                        delete this.frameMap[id];
                    }
                });
            });
        });
    }
    _bindListener() {
        window.addEventListener('message', this._messageHandler.bind(this));
    }
    _messageHandler(event) {
        let eventBody = event.data || {};
        const { source } = event;
        const { type = '', id = '', data = {} } = eventBody;
        const frameId = this._findFrameInMap(source);
        if (!frameId) {
            return;
        }
        if (type === 'init') {
            this.iframeId = data.id;
        }
        this._handleCallbacks(type, frameId, data);
        this._handleQueuedMessage(frameId);
    }
    _findFrameInMap(source) {
        for (let frameId in this.frameMap) {
            const frame = this.frameMap[frameId];
            if (frame.target === source) {
                return frame.id;
            }
        }
        return false;
    }
    _createFrameTemplate(id, target, hasMounted) {
        return {
            id,
            target,
            eventHooks: {},
            mounted: hasMounted,
            messageQueue: [],
        };
    }
    _handleCallbacks(type, id, data) {
        const hooks = this.frameMap[id].eventHooks;
        const callbackList = hooks[type] || [];
        callbackList.forEach((callback) => {
            callback(data);
        });
    }
    _postMessage(target, data) {
        target.postMessage({
            code: 0,
            id: this.iframeId,
            type: data.type,
            data,
        }, '*');
    }
    _handleQueuedMessage(id) {
        var iframe = this.frameMap[id];
        if (!iframe)
            return;
        const isMounted = iframe.mounted;
        if (isMounted)
            return;
        this.frameMap[id].mounted = true;
        this.frameMap[id].messageQueue.forEach(({ id, event, options }) => {
            this.post(id, event, options);
        });
    }
    // 注册目标iframe。
    register(target, hasMounted = false) {
        if (!target) {
            return;
        }
        if (target.nodeName !== 'IFRAME') {
            return;
        }
        const hasRegistered = this._findFrameInMap(target.contentWindow);
        if (hasRegistered) {
            return;
        }
        const id = `iframe-${uuid()}`;
        target.setAttribute(ID, id);
        this.frameMap[id] = this._createFrameTemplate(id, target.contentWindow, hasMounted);
        var handler = this._handleQueuedMessage.bind(this);
        target.contentWindow.addEventListener('load', function () {
            handler(id);
        });
        this.observer.observe(target.parentNode, {
            childList: true,
        });
        return id;
    }
    post(id, event, options) {
        const frame = this.frameMap[id];
        if (!frame) {
            return;
        }
        const mounted = frame.mounted;
        const data = Object.assign({ type: event, id: this.iframeId }, options);
        if (!mounted) {
            frame.messageQueue.push({
                id,
                event,
                options,
            });
        }
        else {
            this._postMessage(frame.target, data);
        }
    }
    postToParent(event, options) {
        const id = this.parentId;
        this.post(id, event, options);
    }
    onParent(event, callback) {
        const id = this.parentId;
        this.on(id, event, callback);
    }
    on(id, event, callback) {
        if (!this.frameMap[id]) {
            return;
        }
        const callbackList = this.frameMap[id].eventHooks[event] || [];
        callbackList.push(callback);
        this.frameMap[id].eventHooks[event] = callbackList;
    }
    offParent(event, callback) {
        const id = this.parentId;
        this.off(id, event, callback);
    }
    off(id, event, callback) {
        if (!this.frameMap[id]) {
            return;
        }
        const callbackList = this.frameMap[id].eventHooks[event] || [];
        this.frameMap[id].eventHooks[event] = callbackList.filter((item) => item !== callback);
    }
    emitClose(options) {
        this.postToParent(PRESET_EVENTS.CLOSE, options);
    }
    emitLoad(options) {
        this.postToParent(PRESET_EVENTS.LOADED, options);
    }
    emitSucceed(options) {
        this.postToParent(PRESET_EVENTS.SUCCEED, options);
    }
}
Client.EVENTS = PRESET_EVENTS;
export default Client;
